import axios from "axios";
if (process.env.NODE_ENV !== 'test') require.context('./', true, /\.jsx$/);

const importPlugin = (namespace) => import(`./${namespace}/index`);

const normalisePlugin = (plugin) => typeof plugin === 'string'
    ? {name: plugin, namespace: plugin}
    : plugin;

export const loadPlugins = async (plugins, importer = importPlugin) => {
    const modules = {};

    for (const entry of plugins) {
        const plugin = normalisePlugin(entry);
        if (!plugin?.namespace) continue;

        const module = await importer(plugin.namespace).then(i => i.default).catch(() => undefined);
        if (module) {
            modules[module.ControlDisplaySettings?.()?.value || plugin.name?.toLowerCase() || plugin.namespace.toLowerCase()] = module;
        }
    }

    return modules;
};

export const plugins = async (plugins, importer = importPlugin) => {
    if (plugins) {
        return loadPlugins(plugins, importer);
    }

    const {data} = await axios.get(`/api/v2/workspaces/current/configuration`);
    return loadPlugins(data?.enabledPlugins ?? [], importer);
};
